import { FC } from 'react'
import { SegmentedControl } from '@cargomart/ui'
import cn from 'classnames'
import { formatCargoSize, formatCargoWeightGramToKilogram } from 'modules/order/helpers/formatCargo'

import CargoSizeControlMobileElement from './CargoSizeControlMobileElement'
import { CargoSizeControlProps } from './types'

export const CargoSizeControlMobile: FC<CargoSizeControlProps<string>> = ({ cargoSize, onChange, value, invalid }) => (
  <div className="pt-2">
    <SegmentedControl
      className="grid !h-auto grid-cols-[repeat(auto-fit,_minmax(3.5em,_1fr))] gap-1 rounded-xl bg-surface-variant p-1"
      onChange={onChange}
      value={value}
    >
      {cargoSize?.map((size) => (
        <CargoSizeControlMobileElement
          key={size.id}
          className={cn(invalid && 'z-10 border border-negative')}
          value={size.id}
        />
      ))}
    </SegmentedControl>
    {cargoSize?.map(
      (size) =>
        value === size.id && (
          <div className="pt-4">
            <div className="text-title-md">{size.name}</div>
            <div className="text-body-md">
              Размер {formatCargoSize(size.length, size.width, size.height, false)}, до{' '}
              {formatCargoWeightGramToKilogram(size.weight)}
            </div>
            <div className="text-body-md text-on-surface-variant">{size.description}</div>
          </div>
        )
    )}
  </div>
)

export default CargoSizeControlMobile
